const NotFound = () => {
  return (
    <div>
      <img
        src="/assets/404.png"
        alt="404 Not Found"
        style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
      />
    </div>
  )
}

export default NotFound
